import React from 'react';
import styled from 'styled-components';
import CancelBordered from 'icons/cancel-bordered';

const CancelIcon = styled(CancelBordered).attrs(({ theme }) => ({
  style: {
    primaryColor: theme.colors.selectableLightBg,
  },
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: ${({ theme: { grid } }) => grid.units(1)};
  width: ${({ theme: { grid } }) => grid.units(1)};
`;

const SuffixListItemContainer = styled.div`
  flex: 1;
  background: transparent;
  display: flex;
  margin: ${({ theme: { grid } }) => grid.units(0.5)};
  margin-right: ${({ theme: { grid } }) => grid.units(1)};
  justify-content: space-between;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.p};
`;

interface SuffixListItemProps {
  label: React.ReactNode;
  onRemove: React.MouseEventHandler<HTMLElement>;
}

export const SuffixListItem = ({ label, onRemove }: SuffixListItemProps): React.JSX.Element => (
  <SuffixListItemContainer>
    <span>{label}</span>
    <CancelIcon onClick={onRemove} type="button" />
  </SuffixListItemContainer>
);
